import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/shared/utils/formatting';

const iconButtonVariants = cva(
  'rounded-full transition-all flex items-center justify-center shrink-0 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-white/10 hover:bg-white/20 text-white',
        surface: 'bg-surface/90 backdrop-blur hover:bg-hover text-text-primary',
        ghost: 'bg-transparent hover:bg-white/10 text-text-secondary hover:text-text-primary',
        close: 'bg-surface/50 hover:bg-surface text-text-secondary hover:text-text-primary',
        play: 'bg-white/90 hover:bg-white text-black shadow-lg hover:scale-110',
        send: 'bg-red-primary hover:bg-red-hover text-white disabled:bg-red-primary/30 disabled:text-white/60',
      },
      size: {
        sm: 'w-8 h-8 [&_svg]:w-4 [&_svg]:h-4',
        md: 'w-10 h-10 [&_svg]:w-5 [&_svg]:h-5',
        lg: 'w-12 h-12 [&_svg]:w-6 [&_svg]:h-6',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

type IconButtonProps = React.ComponentProps<'button'> &
  VariantProps<typeof iconButtonVariants> & {
    'aria-label': string;
  };

function IconButton({ className, variant, size, ...props }: IconButtonProps) {
  return (
    <button
      data-slot="icon-button"
      className={cn(iconButtonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { IconButton, iconButtonVariants, type IconButtonProps };
